const selfSelector = (state) => state.user

export default selfSelector
